module.exports = __webpack_public_path__ + "static/media/class_job_002.d6244145.svg";